import { RenderItemProps, RenderSubItemProps } from './Navigation';
import { createRenderers, ElementCreators } from './renderFactory';

const defaultElementCreators: ElementCreators = {
  createMainElement: ({ containerProps, accessibilityProps, onClick, onKeyDown, content }) => (
    <div {...containerProps} {...accessibilityProps} onClick={onClick} onKeyDown={onKeyDown} tabIndex={0} role="button">
      {content}
    </div>
  ),
  createSubElement: ({ item, className, isDisabled, onClick, onKeyDown }) => (
    <button
      key={item.id}
      type="button"
      className={className}
      onClick={onClick}
      onKeyDown={onKeyDown}
      disabled={isDisabled}
      aria-disabled={isDisabled}
      tabIndex={isDisabled ? -1 : 0}
    >
      {item.label}
    </button>
  ),
};

const { renderItem, renderSubItem } = createRenderers(defaultElementCreators);

export const defaultRenderItem = (props: RenderItemProps) => renderItem(props);
export const defaultRenderSubItem = (props: RenderSubItemProps) => renderSubItem(props);
